module.exports = __webpack_public_path__ + "img/KMS-M-6.bf27f998.svg";